export default __webpack_public_path__ + "static/media/a023-startup2.9e7d7b20.png";